// extracted by mini-css-extract-plugin
export default {"container":"index_container__uBoqa","divBtn":"index_divBtn__3Bl+0","delBtn":"index_delBtn__MyfLA"};